exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-17f04ba6]{font-size:15px;text-align:justify}.input[data-v-17f04ba6]{height:40px;width:350px;font-size:30px}", ""]);

// exports
